<template>
    <div class="rest_list__header">
        <div class="rest_list__header_container space-around">
            <burger_menu
                v-if="isMobileScreen"
                :key="'burger_menu'"
            />
            <header_item_group
                v-for="item in stopListGroups"
                :key="'header_item_group' + item.id"
                :item="item"
                :operationName="'stop_list_groups'"
                @select_item_group="selectItemGroup"
            />
        </div>
    </div>
    <RouterView
        :key="'router_view_stop_list'"
    />
</template>

<script>

import menu_orders from "../../menu/order/MenuOrders.vue";
import {createHelpers} from "vuex-map-fields";
import loader_page from "../../loader/LoaderPage.vue";
import header_item_group from "./HeaderItemGroup.vue";
import burger_menu from "../../heading/BurgerMenu.vue";
import {screenSize} from "../../../mixins/screenSize";

const {mapFields: mUser} = createHelpers({
    getterType: 'user/getUserField',
    mutationType: 'user/updateUserField',
})
const {mapFields: mStopList} = createHelpers({
    getterType: 'stop_list/getStopListField',
    mutationType: 'stop_list/updateStopListField',
})


export default {
    name: "rest_stop_list_page",
    components: {
        burger_menu,
        header_item_group,
        loader_page,
        menu_orders,
    },
    mixins:[
        screenSize
    ],
    data() {
        return {
            showOrdersMenu: false,
        }
    },
    beforeMount() {
        this.$store.dispatch('stop_list/SET_ACTIVE_ITEM_STOP_LIST_GROUPS', this.stopListGroups.find(item => item.isSelect === true));
        this.$store.dispatch('user/STATE_LOAD_PAGE', true);

        EventBus.$on('load_menu_main', this.loadMenuMain);
    },
    beforeUnmount() {
        EventBus.$off('load_menu_main', this.loadMenuMain);
    },
    methods: {
        loadMenuMain() {
            this.$store.dispatch('user/STATE_LOAD_PAGE', false);

            this.$router.push({path: '/rest', name: 'RestStopList'});
        },
        selectItemGroup(itemHeader) {
            this.$store.dispatch('stop_list/SET_ACTIVE_ITEM_STOP_LIST_GROUPS', itemHeader);
            this.stopListGroups.forEach(item => item.isSelect = item === itemHeader);
            if(itemHeader.id === 1) {
                this.$store.dispatch('stop_list/CLEAR_SEARCH_STOP_LIST_FAST');
                this.$router.push({path: '/rest', name: 'RestStopList'});
            }
            if(itemHeader.id === 2) {
                this.$store.dispatch('stop_list/CLEAR_SEARCH_STOP_LIST_REST');
                this.$store.dispatch('stop_list/SET_STATES_LOADING_LIST', {
                    actionName: 'setStatesLoadingList',
                    statesLoading: ['isLoadedSelectAggregatorsLocationsAll'],
                    stateLoad: true
                });
                this.$store.dispatch('stop_list/SELECT_AGGREGATORS_LOCATIONS_ALL', {
                    actionName: 'selectAggregatorsLocationsAll',
                    statesLoading: ['isLoadedSelectAggregatorsLocationsAll'],
                    stateLoad: false,
                });
                this.$router.push({name: 'FastStopList', params:{backState: 0}});
            }
            if(itemHeader.id === 3){
                this.$store.dispatch('stop_list/CLEAR_SEARCH_STOP_LIST_REST');
                this.$router.push({path: '/products_without_groups', name: 'ProductsWithoutGroups'});
            }

        }
    },
    computed: {
        ...mUser([
            'isLoadPage'
        ]),
        ...mStopList([
            'stopListGroups',
            'activeItemStopListGroups',
            'isLoadedStopListProductsWithoutFilter'
        ]),
    }
}
</script>
